import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ControleEstoqueDetalheSerieMovimentadaStruct } from '../../../../../shared/services/structs/produto/controle-estoque-detalhe-serie-movimentada.struct';

export interface SeriesMovimentadasPopoverData {
  descricaoOperacao: string;
  series: ControleEstoqueDetalheSerieMovimentadaStruct[];
}

@Component({
  selector: 'app-series-movimentadas-popover',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './series-movimentadas-popover.component.html',
  styleUrls: ['./series-movimentadas-popover.component.css'],
})
export class SeriesMovimentadasPopoverComponent {
  constructor(
    public dialogRef: MatDialogRef<SeriesMovimentadasPopoverComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SeriesMovimentadasPopoverData
  ) {}

  public fechar(): void {
    this.dialogRef.close();
  }
}
